export var EvmWallet;
(function (EvmWallet) {
    EvmWallet["METAMASK"] = "METAMASK";
    EvmWallet["RAINBOW"] = "RAINBOW";
    EvmWallet["COINBASE"] = "COINBASE";
    EvmWallet["WALLETCONNECT"] = "WALLETCONNECT";
    EvmWallet["ZERION"] = "ZERION";
})(EvmWallet || (EvmWallet = {}));
export var SolanaWallet;
(function (SolanaWallet) {
    SolanaWallet["PHANTOM"] = "PHANTOM";
    SolanaWallet["GLOW"] = "GLOW";
    SolanaWallet["BACKPACK"] = "BACKPACK";
})(SolanaWallet || (SolanaWallet = {}));
// export enum CosmosWallet {
//   KEPLR = 'KEPLR',
//   LEAP = 'LEAP',
// }
export const ExternalWallet = Object.assign(Object.assign({}, EvmWallet), SolanaWallet);
